// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"ba47c4d1","122":"24a2316a","311":"def4dc5d","520":"3abcda91","746":"554012ed","850":"af56d675"}[chunkId] + ".chunk.js";
};